<template>
<nav :class="$style.nav">
    <a
        v-for="(url, name) in links"
        :key="name"
        :href="url"
        target="_blank"
        rel="noopener"
        @click="$nc($event, `fot.${nclkCodes[name]}`)">
        <em v-if="name === 'privacy'">
            {{ $t(`links.${name}`) }}
        </em>
        <template v-else>
            {{ $t(`links.${name}`) }}
        </template>
    </a>
</nav>
</template>

<script>
import { getFooterLinks } from "@/data/links.js";

export default {
    data: () => ({
        nclkCodes: {
            terms: "terms",
            privacy: "privacy",
            privacy_whale: "wpaper",
            help_naver: "help",
            copyright: "corp"
        }
    }),
    computed: {
        locale() {
            return this.$i18n.locale;
        },
        links() {
            return getFooterLinks(this.locale);
        }
    }
};
</script>

<style lang="scss" module>
@use "@/assets/scss/mixins" as m;
@use "@material/typography/typography";

.nav {
    font-size: typography.px-to-rem(12px);
    @include m.md {
        position: relative;
        padding-bottom: 37px;
    }
    a {
        @include m.lg {
            line-height: 22px;
            &:nth-child(5) {
                width: 100%;
                margin-top: 5px;
            }
        }
        @include m.md {
            margin-bottom: 13px;
            line-height: 22px;
            &:nth-child(3) {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 15px;
                margin: auto 0;
            }
            &:nth-child(5) {
                width: max-content;
                margin-top: 0;
            }
        }
        display: inline-block;
        vertical-align: top;
        margin-right: 15px;
        line-height: 37px;
        color: #a0a0a0;
        em {
            color: #000;
        }
    }
}
</style>
